import { SECOND } from '@gorila-shared-ui/components';
import { useEffect } from 'react';
import { Layer, Source } from 'react-map-gl/mapbox';
import { useRecoilValue, useResetRecoilState } from 'recoil';
import {
  DELIVERY_FENCES_LAYER_STYLE,
  DELIVERY_FENCES_NAME_LAYER_STYLE,
  DELIVERY_FENCES_OUTLINE_LAYER_STYLE,
} from '../../../constants/map';
import { useCamera } from '../../../hooks/useCamera';
import {
  deliveryFencesGeojsonState,
  selectedDeliveryFenceGeojsonState,
  selectedDeliveryFenceIdState,
  showDeliveryFencesLayerState,
} from '../../../storage/map';
import { geometryIsPolygon } from '../../../utils/map';

export function DeliveryFencesLayer() {
  const showDeliveryFencesLayer = useRecoilValue(showDeliveryFencesLayerState);
  const deliveryFencesGeojson = useRecoilValue(deliveryFencesGeojsonState);
  const selectedDeliveryFenceGeojson = useRecoilValue(selectedDeliveryFenceGeojsonState);
  const resetSelectedDeliveryFenceId = useResetRecoilState(selectedDeliveryFenceIdState);
  const { fitToLngLats } = useCamera();

  useEffect(() => {
    if (selectedDeliveryFenceGeojson) {
      const geometry = selectedDeliveryFenceGeojson.features[0]?.geometry;
      if (geometryIsPolygon(geometry)) {
        fitToLngLats(geometry.coordinates[0]);
      }
      const timeout = setTimeout(() => {
        resetSelectedDeliveryFenceId();
      }, 5 * SECOND);
      return () => clearTimeout(timeout);
    }
  }, [selectedDeliveryFenceGeojson]);

  if (!deliveryFencesGeojson) {
    return null;
  }

  return (
    <>
      {showDeliveryFencesLayer && (
        <Source
          type="geojson"
          data={deliveryFencesGeojson}
          id="delivery-fences"
        >
          <Layer {...DELIVERY_FENCES_LAYER_STYLE} />
          <Layer {...DELIVERY_FENCES_OUTLINE_LAYER_STYLE} />
          <Layer {...DELIVERY_FENCES_NAME_LAYER_STYLE} />
        </Source>
      )}
      {selectedDeliveryFenceGeojson && !showDeliveryFencesLayer && (
        <Source
          type="geojson"
          data={selectedDeliveryFenceGeojson}
          id="delivery-fences"
        >
          <Layer {...DELIVERY_FENCES_LAYER_STYLE} />
          <Layer {...DELIVERY_FENCES_OUTLINE_LAYER_STYLE} />
          <Layer {...DELIVERY_FENCES_NAME_LAYER_STYLE} />
        </Source>
      )}
    </>
  );
}
